<template>
  <v-col lg="12" id="publications">
    <div class="tab-default">
      <v-tabs v-model="tab" flat :slider-size="0">
        <v-tab v-for="item in items" :key="item.id" :ripple="false">
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item transition="tab-fade" reverse-transition="tab-fade" v-for="(item, index) in tabContent"
          :key="item.id">
          <!-- Hard-coded Publications tab content (index 1) -->
          <v-card flat v-if="index === 1">
            <v-card-text>
              <div class="single-tab-content publication-content">
                <!-- Publication Item 1 - Example with all features -->
                <!-- 一作论文 -->
                <div class="publication-item" v-for="(pub, pubIndex) in publications" :key="pubIndex">
                  <div class="publication-thumbnail" :class="{ 'no-image': !pub.image }">
                    <img v-if="pub.image" :src="pub.image" :alt="pub.title" />
                    <div class="publication-placeholder" v-else>
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                    </div>
                  </div>
                  <div class="publication-details">
                    <div class="publication-venue">
                      <span class="venue-badge" :class="pub.venueClass">{{ pub.venue }}</span>
                      <span class="venue-tag" v-if="pub.highlight">{{ pub.highlight }}</span>
                    </div>
                    <h3 class="publication-title">{{ pub.title }}</h3>
                    <p class="publication-authors" v-html="pub.authors"></p>
                    <div class="publication-abstract-wrapper">
                      <p class="publication-abstract" :class="{ 'expanded': expandedAbstracts.includes(pubIndex) }">
                        {{ pub.abstract }}
                      </p>
                      <button class="abstract-toggle" @click="toggleAbstract(pubIndex)"
                        v-if="pub.abstract && pub.abstract.length > 150">
                        {{ expandedAbstracts.includes(pubIndex) ? 'Show less' : 'Show more' }}
                      </button>
                    </div>
                    <div class="publication-links">
                      <a v-if="pub.paper" :href="pub.paper" target="_blank" class="pub-link pub-link--paper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                          <polyline points="10 9 9 9 8 9"></polyline>
                        </svg>
                        Paper
                      </a>
                      <a v-if="pub.code" :href="pub.code" target="_blank" class="pub-link pub-link--code">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path
                            d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22">
                          </path>
                        </svg>
                        Code
                      </a>
                      <a v-if="pub.project" :href="pub.project" target="_blank" class="pub-link pub-link--project">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="2" y1="12" x2="22" y2="12"></line>
                          <path
                            d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z">
                          </path>
                        </svg>
                        Project
                      </a>
                      <a v-if="pub.video" :href="pub.video" target="_blank" class="pub-link pub-link--video">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polygon points="5 3 19 12 5 21 5 3"></polygon>
                        </svg>
                        Video
                      </a>
                      <a v-if="pub.slides" :href="pub.slides" target="_blank" class="pub-link pub-link--slides">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                          <line x1="8" y1="21" x2="16" y2="21"></line>
                          <line x1="12" y1="17" x2="12" y2="21"></line>
                        </svg>
                        Slides
                      </a>
                      <button v-if="pub.bibtex" @click="copyBibtex(pub.bibtex, pubIndex)"
                        class="pub-link pub-link--bibtex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                          <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                        </svg>
                        {{ copiedIndex === pubIndex ? 'Copied!' : 'BibTeX' }}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- 合作论文分隔区 -->
                <div class="collaborations-section" v-if="collaborations && collaborations.length > 0">
                  <div class="section-divider">
                    <span class="divider-text">Collaborations</span>
                  </div>

                  <!-- 合作论文列表 -->
                  <div class="collab-item" v-for="(collab, collabIndex) in collaborations"
                    :key="'collab-' + collabIndex">
                    <div class="collab-content">
                      <div class="collab-header">
                        <span class="collab-venue-badge" :class="collab.venueClass">{{ collab.venue }}</span>
                        <span class="collab-tag" v-if="collab.tag">{{ collab.tag }}</span>
                      </div>
                      <h4 class="collab-title">{{ collab.title }}</h4>
                      <p class="collab-authors" v-html="collab.authors"></p>
                    </div>
                    <div class="collab-links">
                      <a v-if="collab.paper" :href="collab.paper" target="_blank" class="collab-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                        </svg>
                        Paper
                      </a>
                      <a v-if="collab.code" :href="collab.code" target="_blank" class="collab-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path
                            d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22">
                          </path>
                        </svg>
                        Code
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <!-- Hard-coded News tab content (index 0) -->
          <v-card flat v-else-if="index === 0">
            <v-card-text>
              <div class="single-tab-content news-content" :class="{ 'is-expanded': newsExpanded }">
                <div class="news-year">
                  <div class="news-year-label">2026</div>
                  <ul>
                    <li>
                      <strong>[26 Aug] </strong>
                      <span>Honored to be listed by <a href="https://computing.smu.edu.sg/phd/awards-achievements" target="_blank"
                          class="conference-name conference-link im-hover link">the Dean's List</a> by SMU for the second
                        year. 🎉</span>
                    </li>
                    <li>
                      <strong>[15 Jul] </strong>
                      <span>Awarded the <a href="https://graduatestudies.smu.edu.sg/phd/research-achievements/presidential-doctoral-fellowship" target="_blank"
                          class="conference-name conference-link im-hover link">Presidential Doctoral Fellowship</a> by
                        SMU for the second year. 🎉</span>
                    </li>
                    <li>
                      <strong>[27 Jan] </strong>
                      <span>One paper about scalable efficient multi-task LoRA is accepted by <a href="https://iclr.cc/virtual/2026/poster/10010068"
                          target="_blank" class="conference-name conference-link im-hover link">ICLR'26</a>. See you in
                        Rio de Janeiro, Brazil 🇧🇷! 🌟</span>
                    </li>
                  </ul>
                </div>

                <div class="news-year news-year--older">
                  <div class="news-year-label">2025</div>
                  <ul>
                    <li>
                      <strong>[2 Aug] </strong>
                      <span>Awarded the <a href="https://graduatestudies.smu.edu.sg/phd/research-achievements/presidential-doctoral-fellowship" target="_blank"
                          class="conference-name conference-link im-hover link">Presidential Doctoral Fellowship</a> by
                        SMU. 🎉</span>
                    </li>
                    <li>
                      <strong>[15 Jul] </strong>
                      <span>Honored to be listed by <a href="https://computing.smu.edu.sg/phd/awards-achievements" target="_blank"
                          class="conference-name conference-link im-hover link">the Dean's List</a> by SMU. 🎉</span>
                    </li>
                    <li>
                      <strong>[27 Apr] </strong>
                      <span>Co-organize workshop <a href="https://computing.smu.edu.sg/events/research/workshop/cvml-genai2025" target="_blank"
                          class="conference-name conference-link im-hover link">Advances of Generative AI</a>, the
                        official event in <a href="https://www.smartnation.gov.sg/events/singapore-ai-research-week-2025"
                          target="_blank" class="conference-name conference-link im-hover link">Singapore AI Research
                          Week</a> and ICLR'25, in support of SmartNation 2.0.</span>
                    </li>
                    <li>
                      <strong>[5 Apr] </strong>
                      <span>Our CVPR'25 paper was selected as a <a href="javascript:void(0)"
                          class="conference-name conference-link im-hover link">Highlight of the Conference</a> (top 3%
of submissions)! 🌟</span>
                    </li>
                    <li>
                      <strong>[27 Feb] </strong>
                      <span>One paper about LoRA hyperparameter optimization is accepted by
                        <a href="https://cvpr.thecvf.com/" target="_blank"
                          class="conference-name conference-link im-hover link">CVPR'25</a> with ratings 5/5/4/4 (<a
                          href="https://papercopilot.com/statistics/cvpr-statistics/cvpr-2025-statistics/" target="_blank"
                          class="conference-name conference-link im-hover link">top 0.6%</a> score). 🎉</span>
                    </li>
                    <li>
                      <strong>[9 Jan] </strong>
                      <span>One paper about multi pose generation is accepted by <a href="https://acmmm2025.org/"
                          target="_blank" class="conference-name conference-link im-hover link">TMM</a>. Congrats to
                        Liuqin! 🎉</span>
                    </li>
                    <li>
                      <strong>[6 Jan] </strong>
                      <span>Give research talk at <a href="https://gyss.nrf.gov.sg/" target="_blank"
                          class="conference-name conference-link im-hover link">Global Young Scientist Summit (GYSS)</a>
                        representing SMU. Thanks to Prof Sun for the opportunity!</span>
                    </li>
                  </ul>
                </div>

                <div class="news-year news-year--older">
                  <div class="news-year-label">2024</div>
                  <ul>
                    <li>
                      <strong>[7 Oct] </strong>
                      <span>One paper about long-tailed LoRA adaptation is accepted by <a
                          href="https://neurips.cc/Conferences/2024" target="_blank"
                          class="conference-name conference-link im-hover link">NeurIPS'24</a>. 🎉</span>
                    </li>
                  </ul>
                </div>

                <button class="news-toggle" @click="newsExpanded = !newsExpanded">
                  {{ newsExpanded ? 'Show less' : 'Show earlier news' }}
                </button>
              </div>
            </v-card-text>
          </v-card>

          <!-- Hard-coded Experience tab content (index 2) -->
          <v-card flat v-else-if="index === 2">
            <v-card-text>
              <div class="single-tab-content experience-content">
                <ul>
                  <li>
                    <span><strong>PhD Researcher</strong> - <a href="https://qianrusun.com/" target="_blank"
                        class="conference-name conference-link im-hover link">CVML Lab, SMU</a></span>
                    <div>2023 - Present, Singapore</div>
                  </li>
                  <li>
                    <span><strong>Research Engineer</strong> - <a href="https://qianrusun.com/" target="_blank"
                        class="conference-name conference-link im-hover link">CVML Lab, SMU</a> & <a
                        href="https://www.dso.org.sg/" target="_blank"
                        class="conference-name conference-link im-hover link">DSO National Laboratories</a></span>
                    <div>2023.03 - 2023.08, Singapore</div>
                  </li>
                  <!-- CSAIA Co-Founder（暂时隐藏）
                  <li>
                    <span><strong>Co-Founder</strong> - <a href="https://www.csaia.sg" target="_blank"
                        class="conference-name conference-link im-hover link">China-Singapore AI Association
                        中新人工智能协会</a>
                    </span>
                    <div>2022 - 2023 (Exited), Co-Found with <a href="https://www.cbaia.org.uk" target="_blank"
                        class="conference-name conference-link im-hover link">CBAIA</a>, Singapore</div>
                  </li>
                  -->
                  <li>
                    <span><strong>Research Associate</strong> - <a href="https://www.ntu.edu.sg/s-lab/" target="_blank"
                        class="conference-name conference-link im-hover link">S-Lab of Advanced Intelligence</a></span>,
                    Nanyang
                    Technological University
                    <div>2021 - 2023, Singapore</div>
                  </li>
                  <li>
                    <span><strong>Research Assistant</strong> - <a href="https://s-router.cs.tsinghua.edu.cn/liubin/"
                        target="_blank" class="conference-name conference-link im-hover link">Tsinghua
                        University</a></span>
                    <div>2018 - 2019, Beijing</div>
                  </li>
                  <li>
                    <span><strong>Founder & Principle Designer</strong> - <a href="https://www.haru-maru.com"
                        target="_blank" class="conference-name conference-link im-hover link">春之丸艺术工作室 | Haru-Maru Art &
                        Design Studio</a>
                    </span>
                    <div>Founded in 2018, Beijing</div>
                  </li>
                  <li>
                    <span><strong>Research Intern</strong> - <a href="https://zkl20061823.github.io/" target="_blank"
                        class="conference-name conference-link im-hover link">Beijing University of Posts and
                        Telecommunications</a></span>
                    <div>2017 - 2019, Beijing</div>
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>

          <!-- Hard-coded Education tab content -->
          <v-card flat v-else-if="index === 3">
            <v-card-text>
              <div class="single-tab-content education-content">
                <ul>
                  <li class="education-item">
                    <div class="school-logo">
                      <img src="@/assets/images/logo/smu_logo.png" alt="SMU Logo" />
                    </div>
                    <div class="education-content">
                      <span><strong>PhD in Artifical Intelligence</strong> - <a href="https://www.smu.edu.sg/"
                          target="_blank" class="conference-name conference-link im-hover link">Singapore Management
                          University</a></span>
                      <div>2023 - 2026</div>
                    </div>
                  </li>
                  <li class="education-item">
                    <div class="school-logo">
                      <img src="@/assets/images/logo/ntu_logo.png" alt="NTU Logo" />
                    </div>
                    <div class="education-content">
                      <span><strong>PhD in Computer Science</strong> - <a href="https://www.ntu.edu.sg/computing"
                          target="_blank" class="conference-name conference-link im-hover link">Nanyang Technological
                          University</a></span>
                      <div>2022 - 2023 (Transferred to SMU)</div>
                    </div>
                  </li>
                  <li class="education-item">
                    <div class="school-logo">
                      <img src="@/assets/images/logo/ntu_logo.png" alt="NTU Logo" />
                    </div>
                    <div class="education-content">
                      <span><strong>MSc in Artificial Intelligence</strong> - <a href="https://www.ntu.edu.sg/computing"
                          target="_blank" class="conference-name conference-link im-hover link">Nanyang Technological
                          University</a></span>
                      <div>2020 - 2022</div>
                    </div>
                  </li>
                  <li class="education-item">
                    <div class="school-logo">
                      <img src="@/assets/images/logo/tsinghua_logo.png" alt="Tsinghua Logo" />
                    </div>
                    <div class="education-content">
                      <span><strong>Visiting Student</strong> - <a href="https://www.tsinghua.edu.cn/"
                          target="_blank" class="conference-name conference-link im-hover link">Tsinghua
                          University</a></span>
                      <div>2017 - 2019</div>
                    </div>
                  </li>
                  <li class="education-item">
                    <div class="school-logo">
                      <img src="@/assets/images/logo/bupt_logo.png" alt="BUPT Logo" />
                    </div>
                    <div class="education-content">
                      <span><strong>BEng in Telecommunications</strong> - <a href="https://www.bupt.edu.cn/"
                          target="_blank" class="conference-name conference-link im-hover link">Beijing Univ of Posts
                          and
                          Telecomm</a></span>
                      <div>2015 - 2019</div>
                    </div>
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>

          <!-- Hard-coded Service tab content (index 4) -->
          <v-card flat v-else-if="index === 4">
            <v-card-text>
              <div class="single-tab-content service-content">
                <ul>
                  <li class="service-item">
                    <div class="service-role">Conference Reviewer / PC Member</div>
                    <div class="service-venues">
                      <span class="service-chip">NeurIPS'24 '25</span>
                      <span class="service-chip">CVPR'25</span>
                      <span class="service-chip">ICML'25</span>
                      <span class="service-chip">IJCAI'25</span>
                      <span class="service-chip">AAAI'25</span>
                      <span class="service-chip">ACM MM'24</span>
                    </div>
                  </li>
                  <li class="service-item">
                    <div class="service-role">Journal Reviewer</div>
                    <div class="service-venues">
                      <span class="service-chip">IJCV</span>
                      <span class="service-chip">TNNLS</span>
                    </div>
                  </li>
                  <li class="service-item">
                    <div class="service-role">Workshop Organizer</div>
                    <div class="service-venues">
                      <a href="https://computing.smu.edu.sg/events/research/workshop/cvml-genai2025" target="_blank" class="service-chip service-chip--link">
                        Advances of Generative AI @ ICLR'25 / Singapore AI Research Week</a>
                    </div>
                  </li>
                  <li class="service-item">
                    <div class="service-role">Invited Talk</div>
                    <div class="service-venues">
                      <a href="https://gyss.nrf.gov.sg/" target="_blank" class="service-chip service-chip--link">
                        Global Young Scientist Summit (GYSS) 2025</a>
                    </div>
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
          <!-- Dynamic content for other tabs -->
          <v-card flat v-else>
            <v-card-text>
              <div class="single-tab-content">
                <ul>
                  <li v-for="(content, i) in item.content" :key="i">
                    <a class="link" :href="content.link" target="_blank">
                      {{ content.title }}
                      <span> - {{ content.name }}</span>
                    </a>
                    {{ content.desc }}
                  </li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-col>
</template>
<script>
export default {
  data() {
    return {
      tab: null,
      expandedAbstracts: [], // 跟踪哪些 abstract 已展开
      copiedIndex: null, // 跟踪哪个 bibtex 刚被复制
      newsExpanded: false, // 手机上 News 默认只展开今年
      items: [
        {
          id: 0,
          name: "News",
        },
        {
          id: 1,
          name: "Publications",
        },
        {
          id: 2,
          name: "Experience",
        },
        {
          id: 3,
          name: "Education",
        },
        {
          id: 4,
          name: "Service",
        },
      ],

      tabContent: [
        {
          id: 0,
          content: [],
        },
        {
          id: 1,
          content: [],
        },
        {
          id: 2,
          content: [],
        },
        {
          id: 3,
          content: [],
        },
        {
          id: 4,
          content: [],
        },
      ],

      // Publications data - 一作/主要论文（完整展示）
      // image 字段可以是：
      //   1. require("@/assets/images/publications/your-image.jpg") - 本地图片
      //   2. "https://example.com/image.jpg" - 外部图片链接
      //   3. null - 显示默认占位符
      publications: [
        {
          image: require("@/assets/images/publications/iclr26_mtlora.png"),
          title: "Scalable Multi-Task Low-Rank Model Adaptation",
          authors: "<strong>Zichen Tian</strong>, Antoine Ledent, Qianru Sun",
          venue: "ICLR 2026",
          venueClass: "venue--iclr",
          highlight: null,
          abstract: "Scaling multi-task low-rank adaptation (LoRA) to a large number of tasks induces catastrophic performance degradation, such as an accuracy drop from 88.2% to 2.0% on DOTA when scaling from 5 to 15 tasks. This failure is due to parameter and representation misalignment. We find that existing solutions, like regularization and dynamic routing, fail at scale because they are constrained by a fundamental trade-off: strengthening regularization to reduce inter-task conflict inadvertently suppresses the essential feature discrimination required for effective routing. We propose mtLoRA, a scalable solution with Spectral-Aware Regularization, Block-Level Adaptation, and Fine-Grained Routing.",
          paper: "https://proceedings.iclr.cc/paper_files/paper/2026/hash/791de7c35bb49cfca56744e67f90eef4-Abstract-Conference.html",
          code: "https://github.com/doem97/ICLR26_mtLoRA",
          project: "/mtlora/",
          video: null,
          slides: null,
          bibtex: `@inproceedings{ICLR2026_791de7c3,
 author = {Tian, Zichen and Ledent, Antoine and Sun, Qianru},
 booktitle = {International Conference on Learning Representations},
 editor = {C. Vondrick and B. Hariharan and C. Raffel and L. Pinto and D. Yang and A. Faust},
 pages = {74390--74410},
 title = {Scalable Multi-Task Low-Rank Model Adaptation},
 url = {https://proceedings.iclr.cc/paper_files/paper/2026/file/791de7c35bb49cfca56744e67f90eef4-Paper-Conference.pdf},
 volume = {2026},
 year = {2026}
}`,
        },
        {
          image: require("@/assets/images/publications/cvpr25_highlight_metapeft.png"),
          title: "Meta-Learning Hyperparameters for Parameter Efficient Fine-Tuning",
          authors: "<strong>Zichen Tian</strong>, Yaoyao Liu, Qianru Sun",
          venue: "CVPR 2025",
          venueClass: "venue--cvpr",
          highlight: "🌟 Highlight",
          abstract: "Training large foundation models from scratch for domain-specific applications is almost impossible due to data limits and long-tailed distributions — taking remote sensing (RS) as an example. Fine-tuning natural image pre-trained models on RS images is a straightforward solution. To reduce computational costs and improve performance on tail classes, existing methods apply parameter-efficient fine-tuning (PEFT) techniques, such as LoRA and AdaptFormer. However, we observe that fixed hyperparameters — such as intra-layer positions, layer depth, and scaling factors, can considerably hinder PEFT performance, as fine-tuning on RS images proves highly sensitive to these settings. To address this, we propose MetaPEFT, a method incorporating adaptive scalers that dynamically adjust module influence during fine-tuning.",
          paper: "https://openaccess.thecvf.com/content/CVPR2025/html/Tian_Meta-Learning_Hyperparameters_for_Parameter_Efficient_Fine-Tuning_CVPR_2025_paper.html",
          code: "https://github.com/doem97/metalora",
          project: "/metapeft/",
          video: "https://www.youtube.com/watch?v=3_DaZLZBGD4",
          slides: null,
          bibtex: `@InProceedings{Tian_2025_CVPR,
    author    = {Tian, Zichen and Liu, Yaoyao and Sun, Qianru},
    title     = {Meta-Learning Hyperparameters for Parameter Efficient Fine-Tuning},
    booktitle = {Proceedings of the IEEE/CVF Conference on Computer Vision and Pattern Recognition (CVPR)},
    month     = {June},
    year      = {2025},
    pages     = {23037-23047}
}`,
        },
        {
          image: require("@/assets/images/publications/neurips24_deblora.png"),
          title: "Learning De-Biased Representations for Remote-Sensing Imagery",
          authors: "<strong>Zichen Tian</strong>, Zhaozheng Chen, Qianru Sun",
          venue: "NeurIPS 2024",
          venueClass: "venue--neurips",
          highlight: null,
          abstract: "Remote sensing (RS) imagery, which requires specialized satellites to collect and is difficult to annotate, suffers from data scarcity and class imbalance in certain spectrums. Due to their data scarcity, training large-scale RS models from scratch is unrealistic, and the alternative is to transfer pre-trained models by fine-tuning or a more data-efficient method LoRA. Due to class imbalance, transferred models exhibit strong bias, where features of the major class dominate over those of the minor class. In this paper, we propose debLoRA—a generic training approach that works with any LoRA variants to yield debiased features.",
          paper: "https://proceedings.neurips.cc/paper_files/paper/2024/file/6a8e10164a90d5c3660c3949289f969a-Paper-Conference.pdf",
          code: "https://github.com/doem97/deblora",
          project: "/deblora/",
          video: null,
          slides: null,
          bibtex: `@inproceedings{NEURIPS2024_6a8e1016,
 author = {Tian, Zichen and Chen, Zhaozheng and Sun, Qianru},
 booktitle = {Advances in Neural Information Processing Systems},
 doi = {10.52202/079017-1848},
 editor = {A. Globerson and L. Mackey and D. Belgrave and A. Fan and U. Paquet and J. Tomczak and C. Zhang},
 pages = {57970--57992},
 publisher = {Curran Associates, Inc.},
 title = {Learning De-Biased Representations for Remote-Sensing Imagery},
 url = {https://proceedings.neurips.cc/paper_files/paper/2024/file/6a8e10164a90d5c3660c3949289f969a-Paper-Conference.pdf},
 volume = {37},
 year = {2024}
}`,
        },
      ],

      // Collaborations data - 合作论文（简洁展示）
      // venueClass 用于左侧色条和badge颜色，可选值：venue--cvpr, venue--neurips, venue--iclr, venue--icml, venue--aaai, venue--acl, venue--tmm 等
      collaborations: [
        {
          title: "Towards Efficient Use of Multi-Scale Features in Transformer-Based Object Detectors",
          authors: "Gongjie Zhang, Zhipeng Luo, <strong>Zichen Tian</strong>, Jingyi Zhang, Shijian Lu",
          venue: "CVPR 2023",
          venueClass: "venue--cvpr",
          tag: null,
          paper: "https://openaccess.thecvf.com/content/CVPR2023/html/Zhang_Towards_Efficient_Use_of_Multi-Scale_Features_in_Transformer-Based_Object_Detectors_CVPR_2023_paper.html",
          code: null,
        },
        {
          title: "Spectral Unsupervised Domain Adaptation for Visual Recognition",
          authors: "Jingyi Zhang, Jiaxing Huang, <strong>Zichen Tian</strong>, Shijian Lu",
          venue: "CVPR 2022",
          venueClass: "venue--cvpr",
          tag: null,
          paper: "https://openaccess.thecvf.com/content/CVPR2022/html/Zhang_Spectral_Unsupervised_Domain_Adaptation_for_Visual_Recognition_CVPR_2022_paper.html",
          code: null,
        },
        {
          title: "Fourier Document Restoration for Robust Document Dewarping and Recognition",
          authors: "Chuhui Xue, <strong>Zichen Tian</strong>, Fangneng Zhan, Shijian Lu, Song Bai",
          venue: "CVPR 2022",
          venueClass: "venue--cvpr",
          tag: null,
          paper: "https://openaccess.thecvf.com/content/CVPR2022/html/Xue_Fourier_Document_Restoration_for_Robust_Document_Dewarping_and_Recognition_CVPR_2022_paper.html",
          code: null,
        },
      ],
    };
  },
  mounted() {
    // 检查 URL hash，如果是 #publications 就切换到 Publications tab
    this.checkHashAndSwitchTab();
    window.addEventListener('hashchange', this.checkHashAndSwitchTab);
    // 监听导航栏点击事件
    window.addEventListener('switch-to-publications', this.switchToPublications);
    // 手机端 tab 条：横滑渐隐 + 激活项居中
    this.$nextTick(this.setupTabStrip);
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.checkHashAndSwitchTab);
    window.removeEventListener('switch-to-publications', this.switchToPublications);
    window.removeEventListener('resize', this.updateTabStripEdges);
    if (this.tabStrip) this.tabStrip.removeEventListener('scroll', this.updateTabStripEdges);
  },
  watch: {
    tab() {
      this.$nextTick(this.scrollActiveTabIntoView);
    },
  },
  methods: {
    setupTabStrip() {
      const strip = this.$el.querySelector('.v-tabs-bar');
      if (!strip) return;
      this.tabStrip = strip;
      strip.addEventListener('scroll', this.updateTabStripEdges, { passive: true });
      window.addEventListener('resize', this.updateTabStripEdges);
      this.updateTabStripEdges();
      this.scrollActiveTabIntoView();
    },
    updateTabStripEdges() {
      const strip = this.tabStrip;
      if (!strip) return;
      const max = strip.scrollWidth - strip.clientWidth;
      strip.classList.toggle('is-at-start', strip.scrollLeft <= 2);
      strip.classList.toggle('is-at-end', strip.scrollLeft >= max - 2);
    },
    scrollActiveTabIntoView() {
      const strip = this.tabStrip;
      if (!strip || strip.scrollWidth <= strip.clientWidth) return;
      const active = strip.querySelectorAll('.v-tab')[this.tab || 0];
      if (!active) return;
      const s = strip.getBoundingClientRect();
      const a = active.getBoundingClientRect();
      const target = strip.scrollLeft + (a.left - s.left) - (s.width - a.width) / 2;
      strip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    },
    checkHashAndSwitchTab() {
      if (window.location.hash === '#publications') {
        this.tab = 1; // Publications tab
      }
    },
    switchToPublications() {
      this.tab = 1; // Publications tab
    },
    toggleAbstract(index) {
      const i = this.expandedAbstracts.indexOf(index);
      if (i > -1) {
        this.expandedAbstracts.splice(i, 1);
      } else {
        this.expandedAbstracts.push(index);
      }
    },
    copyBibtex(bibtex, index) {
      navigator.clipboard.writeText(bibtex).then(() => {
        this.copiedIndex = index;
        setTimeout(() => {
          this.copiedIndex = null;
        }, 2000);
      });
    },
  },
};
</script>

<style scoped>
/*
 * ⚠️ Tab 内容的字体样式统一在全局管理：
 *    src/assets/scss/elements/_tab.scss
 * 
 * 这里只放 TabTwo 组件特有的布局样式
 */

/* Education section - flexbox layout */
.education-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.school-logo {
  margin-right: 15px;
  display: flex;
  align-items: center;
}

.school-logo img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.education-content {
  flex: 1;
}
</style>
